import React from 'react'
import BaseDateRangeReport from './BaseDateRangedReport'

export default () => <BaseDateRangeReport
  reportHeader = "Expired Cards Summary Report"
  reportDownloadName = "expiredCardsSummaryReport"
  apiReportName = "breakageSummaryReport"
/>
